var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLithuania(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 3",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#C1272D",
    width: 5,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#006A44",
    width: 5,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FDB913",
    width: 5,
    height: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLithuania);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1IDMiPgo8cmVjdCBmaWxsPSIjQzEyNzJEIiB3aWR0aD0iNSIgaGVpZ2h0PSIzIi8+CjxyZWN0IGZpbGw9IiMwMDZBNDQiIHdpZHRoPSI1IiBoZWlnaHQ9IjIiLz4KPHJlY3QgZmlsbD0iI0ZEQjkxMyIgd2lkdGg9IjUiIGhlaWdodD0iMSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };